import { Breadcrumb, Divider } from "antd";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../store/store";

interface Props
{
      breadcrumb?: { title: string; path?: string }[];
      extra?: ReactNode;
}

export default function HeaderContent({ breadcrumb, extra }: Props)
{
      const commonSystem = useSelector((state: RootState) => state.appCommonSlice.commonSystem)
      function itemRender(currentRoute: any, params: any, items: any)
      {
            const isLast = currentRoute?.path === items[items.length - 1]?.path;

            return isLast ? (
                  <span className="text-[#E1EFFA]">
                        {currentRoute.title}
                  </span>
            ) : (
                  <Link
                        className="!text-[#E1EFFA]"
                        to={currentRoute.path || ""}
                  >
                        {currentRoute.title}
                  </Link>
            );
      }
      return (
            <div className="flex justify-between items-center w-full">
                  <div className="flex items-center">
                        <p style={{ fontSize: "20px", fontWeight: 500, color: "#E1EFFA" }}>
                              {commonSystem?.titleApp}
                        </p>
                        <Divider type="vertical" />
                        {/* breadcrumb */}
                        {breadcrumb && (
                              <Breadcrumb
                                    items={breadcrumb}
                                    itemRender={itemRender}
                                    className="[&_*]:text-gray-300"
                              />
                        )}
                  </div>

                  {/* action button */}
                  <div className="flex items-center gap-2">{extra}</div>
            </div>
      );
}
